/**
 *  This fn capitalize first letter.
 */
export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * This fn returns the string in Pascal Case.
 */
export const toSentenceCase = (name: string) => {
  return name
    .split(' ')
    .map((word, i) => {
      if (i === 0) {
        return word.charAt(0).toUpperCase() + word.substring(1);
      } else {
        return word.charAt(0).toLowerCase() + word.substring(1);
      }
    })
    .join(' ');
};

/**
 * This fn returns the string in Kebab Case.
 */
export const toKebabCase = (name: string) => {
  return name
    .split(' ')
    .map((w) => w.toLowerCase())
    .join('-');
};
